module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/filterWithAlertIcon@2x-192b3742457b8be9b0a7fd122921010e.png";